// Блок 10: Финальный CTA

import { Button } from '../ui/Button';

export function FinalCtaSection(): JSX.Element {
  return (
    <section className="py-20 lg:py-28 bg-surface-base">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="relative rounded-panel bg-gradient-to-br from-accent-brand-light via-white to-accent-ai-light/30 border border-border-subtle p-10 sm:p-16 text-center overflow-hidden">
          {/* Subtle glow */}
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(79,70,229,0.06)_0%,_transparent_70%)]" />

          <div className="relative z-10">
            <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-text-primary tracking-tight leading-tight">
              Готовы освободить команду{' '}
              <br className="hidden sm:block" />
              от рутины?
            </h2>

            <p className="mt-4 text-text-secondary text-base sm:text-lg leading-relaxed max-w-md mx-auto">
              14&nbsp;дней бесплатно. Без привязки карты. Настройка за&nbsp;5&nbsp;минут.
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <Button variant="primary" size="xl" onClick={() => { window.location.href = '/demo'; }}>
                Начать бесплатно
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
